/**
 * @enum {SankeyTouchpointInfoConfigWidgetType}
 */
export default {
    BAR: 1,
    DETAILS_TABLE: 2
};